import { create } from 'zustand';

/**
 * Mobile navigation drawer state.
 *
 * On phone-width screens the persistent sidebar is hidden and its navigation
 * is presented as a slide-in drawer opened from the header hamburger. This
 * store is the shared open/close state between the Header (which opens it) and
 * the drawer itself (rendered in AppShell).
 */
interface MobileNavState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useMobileNavStore = create<MobileNavState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}));
